export default __webpack_public_path__ + "static/media/facil4.29f757d3.png";